import { render, staticRenderFns } from "./download_gs.vue?vue&type=template&id=340109ce&scoped=true&"
import script from "./download_gs.vue?vue&type=script&lang=js&"
export * from "./download_gs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340109ce",
  null
  
)

export default component.exports